import { DevelopmentInfoContainer } from "./DevelopmentInfo.styles";

export const DevelopmentInfo = () => {
  const deploymentServerName = window.RUNTIME_CONFIG.deployEnv;

  return deploymentServerName === "prod" ? null : (
    <DevelopmentInfoContainer>
      <div className="development-server-name">
        {deploymentServerName?.toUpperCase()} environment
      </div>
    </DevelopmentInfoContainer>
  );
};
